<app-header-one></app-header-one>

<div class="page-title-area page-title-bg3">
    <div class="container">
        <div class="page-title-content">
            <h2>Categories</h2>
        </div>
    </div>
</div>

<section class="listing-categories-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-categories-listing-item bg1">
                    <div class="icon">
                        <i class='bx bx-shopping-bag'></i>
                    </div>
                    <h3>Shops</h3>
                    <span>60 Listing</span>

                    <a routerLink="/listing-one" class="learn-more-btn">Learn More <i class='bx bx-chevron-right'></i></a>

                    <a routerLink="/listing-one" class="link-btn"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-categories-listing-item bg2">
                    <div class="icon">
                        <i class='bx bx-bed'></i>
                    </div>
                    <h3>Hotels</h3>
                    <span>21 Listing</span>

                    <a routerLink="/listing-one" class="learn-more-btn">Learn More <i class='bx bx-chevron-right'></i></a>

                    <a routerLink="/listing-one" class="link-btn"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-categories-listing-item bg3">
                    <div class="icon">
                        <i class='bx bx-drink'></i>
                    </div>
                    <h3>Restaurants</h3>
                    <span>58 Listing</span>

                    <a routerLink="/listing-one" class="learn-more-btn">Learn More <i class='bx bx-chevron-right'></i></a>

                    <a routerLink="/listing-one" class="link-btn"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-categories-listing-item bg4">
                    <div class="icon">
                        <i class='bx bx-dumbbell'></i>
                    </div>
                    <h3>Fitness</h3>
                    <span>99 Listing</span>

                    <a routerLink="/listing-one" class="learn-more-btn">Learn More <i class='bx bx-chevron-right'></i></a>

                    <a routerLink="/listing-one" class="link-btn"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-categories-listing-item bg5">
                    <div class="icon">
                        <i class='bx bx-calendar-star'></i>
                    </div>
                    <h3>Events</h3>
                    <span>21 Listing</span>

                    <a routerLink="/listing-one" class="learn-more-btn">Learn More <i class='bx bx-chevron-right'></i></a>

                    <a routerLink="/listing-one" class="link-btn"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-categories-listing-item bg6">
                    <div class="icon">
                        <i class='bx bx-walk'></i>
                    </div>
                    <h3>Services</h3>
                    <span>49 Listing</span>

                    <a routerLink="/listing-one" class="learn-more-btn">Learn More <i class='bx bx-chevron-right'></i></a>

                    <a routerLink="/listing-one" class="link-btn"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-categories-listing-item bg7">
                    <div class="icon">
                        <i class='bx bx-building-house'></i>
                    </div>
                    <h3>Hospital</h3>
                    <span>21 Listing</span>

                    <a routerLink="/listing-one" class="learn-more-btn">Learn More <i class='bx bx-chevron-right'></i></a>

                    <a routerLink="/listing-one" class="link-btn"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-categories-listing-item bg8">
                    <div class="icon">
                        <i class='bx bx-cog'></i>
                    </div>
                    <h3>Others</h3>
                    <span>12 Listing</span>

                    <a routerLink="/listing-one" class="learn-more-btn">Learn More <i class='bx bx-chevron-right'></i></a>

                    <a routerLink="/listing-one" class="link-btn"></a>
                </div>
            </div>
        </div>
    </div>
</section>

<app-partner></app-partner>